import { PureComponent } from 'react';
import { Typography } from 'omakase';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  option: any;
}

export default class ConsumerDropdownOption extends PureComponent<Props> {
  render() {
    return (
      <div className="ConsumerDropdownOption">
        <Typography color="inherit" component="span" variant="body02">
          {this.props.option.label}
        </Typography>
      </div>
    );
  }
}
